<template>
	<div class="xiangmu">
		<breadcrumb :routerList="[{to:'/dingd/bsc',title:'订单管理'},{title:'内销标准订单'}]"/>
		<div class="h-piece h-mrt30">
			<div class="h-formBox">
            <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
               <el-form-item label="经销商名称" style="position:relative;">
                  <input placeholder="模糊查询" style="width:100px; padding:0" 
                  v-model="input_value" 
                  @keyup="throttle" 
                  ref="input"/>
                  <ul v-show="state" class="ul" >
                     <li v-for="item in dataList" :key="item" @click="dianji">
                        <span>{{item.name}}</span>
                     </li>
                  </ul>

               </el-form-item>
               <el-form-item label="销售区域">
                  <el-select v-model="formInline.lei"  style="width:1.5rem">
                        <el-option label="客户一" value="1"></el-option>
                        <el-option label="客户二" value="2"></el-option>
                  </el-select>
               </el-form-item>
               <el-form-item label="销售渠道">
                  <el-select v-model="formInline.type"  style="width:1.2rem">
                     <el-option label="类别1" value5="1"></el-option>
                     <el-option label="类别2" value6="2"></el-option>
                  </el-select>
               </el-form-item>
               <el-form-item label="经销商状态">
                  <el-select v-model="formInline.guanxi"  style="width:1.2rem">
                        <el-option label="类别1" value="1"></el-option>
                        <el-option label="类别2" value="2"></el-option>
                  </el-select>
               </el-form-item>
               <el-form-item label="经销商级别">
                  <el-select v-model="formInline.jibie"  style="width:1.2rem">
                        <el-option label="类别1" value="1"></el-option>
                        <el-option label="类别2" value="2"></el-option>
                  </el-select>
               </el-form-item>
               <el-form-item class="h-formBtnOut">
                  <!-- <el-button class="h-btn h-formBtn" >检索</el-button> -->
                  <el-button class="h-btn h-formBtn h-bggreen h-mr20" icon="el-icon-plus" style="width:1.6rem;">新增经销商</el-button>
               </el-form-item>
         </el-form>
			</div>
		</div>
		<div class="h-table h-mrt30" v-if="clickActive==1">
			<el-table
				
				@selection-change="handleSelectionChange"
				:data="tableData2"
				
				style="width: 100%"
				>
				<el-table-column
					type="selection"
					width="70"
					:label="all">
				</el-table-column>
				<el-table-column
					
					type="index"
					label="序号"
					width="50">
				</el-table-column>
				<el-table-column
					prop="customerName"
					label="经销商名称"
					 :show-overflow-tooltip="true"
					width="120">
				</el-table-column>
				<el-table-column
					prop="visitTime"
					label="到期时间"
					 :show-overflow-tooltip="true"
					width="150">
				</el-table-column>
				<el-table-column
					prop="contact"
					label="销售区域"
					width="120">
				</el-table-column>
				<el-table-column
					prop="objective"
					label="销售渠道"
					width="100">
				</el-table-column>
				<el-table-column
					prop="category"
					label="状态"
					width="100">
				</el-table-column>
				<el-table-column
					prop="status"
					label="级别"
					width="80">
				</el-table-column>
				<el-table-column
					prop="price"
					label="销售资质"
					width="100">
				</el-table-column>
				
				<el-table-column label="操作" fixed="right" width="300">
					<template slot-scope="scope">
						<el-button
							type="text"
							size="small"
							class="h-tableLink h-btn">
								查看
						</el-button>
                  <el-button
							type="text"
							size="small"
							class="h-tableLink h-btn">
								冻结
						</el-button>
                  <el-button type="text" @click="centerDialogVisible = true">延期</el-button>
						<el-button type="text" @click="centerDialogVisible = true">解冻</el-button>
						<el-dialog
							:visible.sync="centerDialogVisible"
							width="40%"
							height="50%;"
							:before-close="handleClose"
							show-close="false"
							>
						<img v-if="xuqiudex==index" src="../../../assets/images/h-dialogImg.png" style="margin-left:-21px; width:540px;margin-top:-60px;padding-bottom:50px;"/>
						<br>
						<span>青岛医疗XXX公司</span>
						<el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">						
							<el-form-item label="到期日调整">
								<el-col :span="11">
									<el-date-picker type="date" placeholder="选择时间" v-model="formInline.date1" ></el-date-picker>
								</el-col>
							</el-form-item>
						</el-form>
						<span slot="footer" class="h-btn" style="">
							<el-button @click="centerDialogVisible = false">取 消</el-button>
							<el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
						</span>
						</el-dialog>
                  <el-button
							type="text"
							size="small"
							class="h-tableLink h-btn"
                     >
								审批
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="h-tableB h-mrt30">
				<!-- <div class="h-tableBL">
					<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" style="margin-left:-20px;">批量导出</el-button>
				</div> -->
				<div class="h-pagination2">
					<span class="h-pagiLabel">显示数量:</span>
					<el-pagination
						
						:current-page="4"
						:page-sizes="[10, 20, 30, 40]"
						:page-size="10"
						layout="sizes, prev, pager, next,jumper"
						:total="400">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data(){
      return{
         centerDialogVisible: false,
         //表单
         dataList:[
         {  name: "哈哈" },
         {  name: "呵呵" },
         {  name: "晓丽" },  
         {  name: "小兰" },
         {  name: "财务" },
         {  name: "嘻嘻" },
         {  name: "测试" }],  
         list:[],
         input_value:"",
         state:false,
       
			all:'全部',
			formInline:{
				date1:'',
				customerName:'',
				guanxi:'',
				jibie:'',
				lei:'',
				value:'',
				date3:'',
				type:''
			},
			//表格
			multipleSelection: [],
			tableData2: [],
				clickActive:1
      }
    },
	methods:{
		//表格
		handleSelectionChange(val) {
			this.multipleSelection = val;
        },
      dianji(){
         if(item){
            this.input_value = v.name;
           
            this.state = false
         }
      },
      throttle(){
         console.log(this.input_value)
         this.dataList.forEach(v=>{
            if(this.input_value == v.name){
               this.state=true;
               
            }
         })
         // this.dianji()

      },
      // 延期弹窗
      createdemand(){
          this.dialogFormVisible1 = true;
      },
		lineChart(){
			let lineChart = this.$echarts.init(document.getElementById('h_lineChart'));
			let option = {
				tooltip: {
					trigger: 'axis',
					axisPointer:{
						show: true,
						lineStyle: {
							width : 1,
							color:'#61a0f7'
						}
				   }
				},
				legend: {
					show:false
				},
				calculable: true,
				
				yAxis: [{
					type: 'value',
					axisLine: {
						show:false
					},
					splitLine: {
						show:false
					},
					axisTick:{
						show:false
					},
					axisLabel: {
						show:false
					}
				}],
				series: [{
						name: '跑步排名',
						type: 'line',
						symbol: 'circle',
						symbolSize: 0,
						showSymbol: false,
						areaStyle:{
							color: {
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [{
									offset: 0, color: 'rgba(145,188,250,1)' // 0% 处的颜色
								},{
									offset: 0.5, color: 'rgba(145,188,250,0.5)' // 0% 处的颜色
								}, {
									offset: 1, color: 'rgba(145,188,250,0)' // 100% 处的颜色
								}],
								globalCoord: false // 缺省为 false
							},
						},
						smooth:true,
						data: [30,58,98,52,68,30,88],
						lineStyle:{
							color:'#61a0f7'
						},
						itemStyle: {
							normal: {
								color: '#ffffff',
								borderColor: '#61a0f7',
								borderWidth: 2
							}
						}
					}
				]
			};
			lineChart.setOption(option);
		}
	  },
	  mounted(){
		  this.lineChart();
	  },
}
</script>
<style scoped>
.xuqiuBoxList .xuqiulist{
	width: 200px;
	height: 62px;
	border-radius: 4px;
	background: #fff;
	border: 1px solid #959595;
	text-align: center;
	line-height: 62px;
	color: #989898;
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
    margin-left: 10px;
}
.xuqiuBoxList .xuqiulist:first-child{
    margin-left: 0
}
.xuqiuBoxList .xuqiulist.active{
	background: #238cfd;
	border: 1px solid #238cfd;
	color: #fff;
}
.xuqiutext{
	color: #bcbcbc;
	font-size: 14px;
	margin-bottom: 14px;
}
   .xuqiuBoxList{
	width: 100%;
	margin-top: 30px;
	display: flex;
	justify-content: space-between;
}
   .ul{
      position: absolute;
      background: #fff;
      padding: 5px 10px 5px 10px;
      z-index: 9;
      height: 100px;
      overflow-y: auto;
      text-align: center
   }
   .ul li:hover{
      background: #ccc;
      cursor: pointer;
   }
   .ul::-webkit-scrollbar{
      width: 0;
      display: none;
   }
	.xiangmu .h-piece, .h-mrt30{
   	    margin: 20px;
    } 
	/* .h-formBtnOut  .h-mr20{
		margin-left:0.3rem !important;
	} */
    
</style>
<style>
/* .el-table__header .el-table-column--selection .cell .el-checkbox::after{
    content: "全选";
    color:white;
    background-color: rgb(93, 172, 236);
} */
</style>


